import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { changePassword } from "../services/userService";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import FormComponent from "./common/formComponent";
import { Paper } from "@material-ui/core";

class ChangePassword extends FormComponent {
  state = {
    data: {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    },
    errors: {},
    processing: false,
  };

  schema = {
    currentPassword: Joi.string().required().label("Current Password"),
    newPassword: Joi.string().required().label("New Password"),
    confirmNewPassword: Joi.string().required().label("Confirm Password"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const { data } = this.state;
    try {
      await changePassword(data);
      toast.success("Password Changed");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  render() {
    const { data, errors, processing } = this.state;
    return (
      <Paper elevation={3}>
        <div className="card">
          <div className="card-header main-color-bg">
            <h5>Change Pssword</h5>
          </div>
          <div className="card-body">
            <span className="card-text">
              <Form className="mt-4" onSubmit={this.handleSubmit}>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={3}>
                    Current Password
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="currentPassword"
                      onChange={this.handleChange}
                      value={data.currentPassword}
                      size="sm"
                      type="password"
                    />
                    {errors.currentPassword && <span className="text-danger">{errors.currentPassword}</span>}
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={3}>
                    New Password
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="newPassword"
                      onChange={this.handleChange}
                      value={data.newPassword}
                      size="sm"
                      type="password"
                    />
                    {errors.newPassword && <span className="text-danger">{errors.newPassword}</span>}
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={3}>
                    Confirm New Password
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="confirmNewPassword"
                      onChange={this.handleChange}
                      value={data.confirmNewPassword}
                      size="sm"
                      type="password"
                    />
                    {errors.confirmNewPassword && <span className="text-danger">{errors.confirmNewPassword}</span>}
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Col sm={{ span: 9, offset: 3 }}>
                    <Button disabled={this.validate() || processing} type="submit">
                      {processing && (
                        <Spinner
                          as="span"
                          className="mr-2"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Change Password
                    </Button>
                  </Col>
                </Form.Group>
              </Form>
            </span>
          </div>
        </div>
      </Paper>
    );
  }
}

export default ChangePassword;
